/**
 * Formatadores PT-PT consistentes em toda a app maisenergia.
 */

const eurFmt = new Intl.NumberFormat("pt-PT", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const intFmt = new Intl.NumberFormat("pt-PT", {
  maximumFractionDigits: 0,
})

const decFmt = new Intl.NumberFormat("pt-PT", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function formatEur(value: number | string | null | undefined): string {
  const n = typeof value === "number" ? value : Number(value)
  if (!Number.isFinite(n)) return "—"
  return eurFmt.format(n)
}

export function formatKwh(value: number | string | null | undefined): string {
  const n = typeof value === "number" ? value : Number(value)
  if (!Number.isFinite(n)) return "—"
  return `${intFmt.format(n)} kWh`
}

export function formatKwp(value: number | string | null | undefined): string {
  const n = typeof value === "number" ? value : Number(value)
  if (!Number.isFinite(n)) return "—"
  return `${decFmt.format(n)} kWp`
}

export function formatKva(value: number | string | null | undefined): string {
  const n = typeof value === "number" ? value : Number(value)
  if (!Number.isFinite(n)) return "—"
  return `${decFmt.format(n)} kVA`
}

export function formatPct(value: number | string | null | undefined): string {
  const n = typeof value === "number" ? value : Number(value)
  if (!Number.isFinite(n)) return "—"
  return `${decFmt.format(n * 100)}%`
}

export function formatYears(value: number | string | null | undefined): string {
  const n = typeof value === "number" ? value : Number(value)
  if (!Number.isFinite(n)) return "—"
  return `${decFmt.format(n)} anos`
}

const dateFmt = new Intl.DateTimeFormat("pt-PT", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
})

const dateTimeFmt = new Intl.DateTimeFormat("pt-PT", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
})

export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return "—"
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return "—"
  return dateFmt.format(d)
}

export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return "—"
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return "—"
  return dateTimeFmt.format(d)
}

export function relativeFromNow(value: string | Date | null | undefined): string {
  if (!value) return "—"
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return "—"
  const diffMs = Date.now() - d.getTime()
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24))
  if (days === 0) return "hoje"
  if (days === 1) return "há 1 dia"
  if (days < 7) return `há ${days} dias`
  if (days < 14) return "há 1 semana"
  if (days < 30) return `há ${Math.floor(days / 7)} semanas`
  if (days < 60) return "há 1 mês"
  if (days < 365) return `há ${Math.floor(days / 30)} meses`
  return `há ${Math.floor(days / 365)} anos`
}

/**
 * Nome-base de ficheiro para um orçamento: referência + nome do cliente
 * normalizado (sem acentos, só alfanumérico + hífens). Ex.:
 *   ("SOL-2026-0528/2", "Sérgio Cabecinhas") → "SOL-2026-0528-2-Sergio-Cabecinhas"
 * Usado no download do PDF e no nome do anexo de email.
 */
export function proposalFileBase(number: string, clientName?: string | null): string {
  const ref = (number ?? "").replace(/\//g, "-")
  const name = (clientName ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
  return name ? `${ref}-${name}` : ref
}

/**
 * Nome da encomenda no Odoo para mostrar. Neste Odoo as cotações em rascunho
 * chamam-se «/» até serem enviadas/confirmadas (aí ganham «PR 2026/0xxx») —
 * mostrar «/» parecia um erro.
 */
export function odooOrderLabel(name: string | null | undefined, id?: number | string | null): string {
  const n = (name ?? "").trim()
  if (n && n !== "/") return n
  return id != null && String(id) !== "" ? `cotação em rascunho #${id}` : "cotação em rascunho"
}

